import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { ButtonItem } from '@atlaskit/menu';
import { messages } from './messages';
import { copyToClipboard, getProjectTypeURLString } from './utils';
export const CopyDirectLink = ({
  projectType,
  projectKey,
  simplifiedProject,
  issueFormInfo,
  onCloseParent
}) => {
  const intl = useIntl();
  if (!issueFormInfo || (issueFormInfo === null || issueFormInfo === void 0 ? void 0 : issueFormInfo.length) === 0) return null;
  const handleClick = info => () => {
    const url = `${window.location.origin}/jira/${getProjectTypeURLString(projectType, simplifiedProject)}/projects/${projectKey}/forms/form/direct/${info.projectFormId}/${info.issueType.id}${info.requestType ? `?requestTypeId=${info.requestType.id}` : ''}`;
    copyToClipboard(url);
    onCloseParent();
  };
  if (issueFormInfo.length === 1) {
    const rt = issueFormInfo[0];
    return /*#__PURE__*/React.createElement(DropdownItem, {
      onClick: handleClick(rt)
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.copyDirectLinkLabel));
  }
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    placement: "right-start",
    trigger: ({
      triggerRef,
      ...triggerProps
    }) => /*#__PURE__*/React.createElement(ButtonItem, _extends({}, triggerProps, {
      ref: triggerRef,
      iconAfter: /*#__PURE__*/React.createElement(ChevronRightIcon, {
        label: ""
      })
    }), /*#__PURE__*/React.createElement(FormattedMessage, messages.copyDirectLinkLabel))
  }, /*#__PURE__*/React.createElement(DropdownItemGroup, {
    title: intl.formatMessage(projectType === 'service_desk' ? messages.requestTypesHeader : messages.issueTypesHeader)
  }, issueFormInfo.map(info => {
    var _info$requestType;
    const rt = (_info$requestType = info.requestType) !== null && _info$requestType !== void 0 ? _info$requestType : info.issueType;
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: rt.id,
      elemBefore: /*#__PURE__*/React.createElement("img", {
        src: rt.icon,
        alt: ""
      }),
      onClick: handleClick(info)
    }, rt.name);
  })));
};